import { Injectable } from '@angular/core';

import { Api, User } from '../';

@Injectable()
export class Item {

  base_url = '';
  constructor(public api: Api, public user:User) {
    this.base_url = api.url;
   }

  get(params?: any) {
    return this.api.get('index.php/asset/item', params);
  }

  get_detail(params?: any) {
    if(params.id==undefined){
      params.id = 0;
    }
    return this.api.get('index.php/asset/item/detail/'+params.id, params);
  }

  getHistory(params?:any){
    return this.api.get('index.php/asset/item/history', params);
  }

  getImages(params?: any) {
    return this.api.get('index.php/asset/item/images', params);
  }

  save(params?: any) {
    if(params.id>0){
      params.updated_by = this.user.data.employee_id;
    }else{
      params.created_by = this.user.data.employee_id;
    }
    return this.api.post('index.php/asset/item', params);
  }

  save_image(params?: any) {
    return this.api.post('index.php/asset/item/save_image', params);
  }

  listReport(){
    let list = [
      {
        text:'Laporan Stok Opname',
        url:'lap_stok_opname'
      },
      {
        text:'Laporan Review Item',
        url:'lap_review'
      },
      {
        text:'Laporan Kondisi',
        url:'lap_kondisi'
      },
      {
        text:'Laporan Klasifikasi',
        url:'lap_klasifikasi'
      }
    ];
    return list;
  }

  getEmployee(params?: any){
    return this.api.get('index.php/asset/item/employee', params);
  }

  listPIC(){
    let pic = [{
      name : 'Rifai'
    },{
      name : 'M. Taufiq'
    },{
      name : 'Tedha H'
    }];
    return pic;
  }

  image_post(params?: any){
    if(params.id>0){
      params.updated_by = this.user.data.employee_id;
    }
    // else{
    //   params.created_by = this.user.data.employee_id;
    // }
    return this.api.post('index.php/asset/item/image', params);
  }

  getPerbaikan(params?: any){
    return this.api.get('index.php/asset/item/perbaikan', params);
  }

  savePerbaikan(params?: any){
    if(params.id>0){
      params.updated_by = this.user.data.employee_id;
    }
    else{
      params.created_by = this.user.data.employee_id;
    }
    return this.api.post('index.php/asset/item/perbaikan', params);
  }

}



// WEBPACK FOOTER //
// ./src/providers/asset/item/item.ts